import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as Website from '../Config/Website.js';


const Section = () => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    trigger: ".js-spot",
    start: "0% 10%",
    end:'100% 0%',
    toggleClass: "is-active",
    // markers:true,
  });
  ScrollTrigger.create({
    trigger: ".js-sticky",
    start: "0% 60%",
    end:'100% 0%',
    toggleClass: "is-active",
    // markers:true,
  });
}

const init = () => {
  Section();
}
export default init;